import '../css/styles.css'
import { initializeFX } from './scriptthree.js';
const Parse = require('parse');

const STORAGE_ROOT = 'fnsz_app_last_';
const SERVER_URL = 'https://funsizeapps.b4a.app/';
const PEVENTS_ENDPOINT = 'getPersonalEvents';
const CEVENTS_ENDPOINT = 'getCompanyEvents';
const HEVENTS_ENDPOINT = 'getHowdyEvents';
const APP_ID = 'rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9';
const JAVASCRIPT_KEY = 'xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv';
const REST_API_KEY = 'fabjEVYWZCwtBWXZ62BF3oAjU7ZzipumKecJidKJ';
Parse.initialize(APP_ID, JAVASCRIPT_KEY);
Parse.serverURL = SERVER_URL;

var funsizer, funsizerId, funsierIdToken, pEventsLoaded, cEventsLoaded, hEventsLoaded, pEvents, cEvents, hEvents, eventRules;

const icons = [{keyword: 'Anniversary', image: new URL('../svgs/event-Anniversary.svg', import.meta.url)}, 
               {keyword: 'Birthday', image: new URL('../svgs/event-Birthday.svg', import.meta.url)}, 
               {keyword: 'CoffeeChat', image: new URL('../svgs/event-CoffeeChat.svg', import.meta.url)},
               {keyword: 'Default', image: new URL('../svgs/event-Default.svg', import.meta.url)},
               {keyword: 'HappyHour', image: new URL('../svgs/event-HappyHour.svg', import.meta.url)},
               {keyword: 'MagicHour', image: new URL('../svgs/event-MagicHour.svg', import.meta.url)},
               {keyword: 'PayDay', image: new URL('../svgs/event-PayDay.svg', import.meta.url)},
               {keyword: 'TeamLunch', image: new URL('../svgs/event-TeamLunch.svg', import.meta.url)},
               {keyword: 'MapPin', image: new URL('../svgs/map-pin.svg', import.meta.url)},
               {keyword: 'MapPinWhite', image: new URL('../svgs/map-pin-white.svg', import.meta.url)}];

window.addEventListener('load', () => {
  gsap.to(document.getElementsByClassName('loader-container')[0], {opacity: 1, duration: 0.25});
  gsap.to(document.getElementsByClassName('loader')[0], {scale: 0.5, duration: 1, ease: "bounce.out", repeat: -1, yoyo: true});
  document.getElementById('btn_logout').addEventListener('click', ()=>{
    Parse.User.logOut().then(() => {
      initFunsizer(); 
    });
  });
  initFunsizer(); 
  const hiddens = document.querySelector('nav').getElementsByClassName('hidden');
  for(var i = 0; i < hiddens.length; i++){
    gsap.to(hiddens[i], {opacity: 1, duration: 0.35, delay: 0.2*i});
  }
});

const initFunsizer=()=>{
    funsizer = Parse.User.current();
    if (funsizer) {
        getFunsizerId().then((id) => {
            funsizerId = id;
            var obj = funsizer.get('authData');
            funsierIdToken = obj.google.id_token;

            if (funsizer.get("accessToken")) { 
                listEvents();
            }
            else {
              window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}eventauth.html?redirect=${window.location.pathname}`;
            }
        }).catch(function(e){ 
          handleParseError('Error getting your Funsizer info ', e);
        });
    } else {
      window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}login.html?redirect=${window.location.pathname}`;
    }
}

async function getFunsizerId(){
  const id = localStorage.getObject('funsizer_id');
  if(id == null) { 
    const query = new Parse.Query(Parse.User);
    query.equalTo('email', funsizer.get('email'));
    try {
        const user = await query.find();
        localStorage.setObject('funsizer_id', user[0].id);
        return user[0].id;
    } catch (error) {
        throw(error);    
    }
  }
  return id;
}

/**
 * Calendar Calls
*/
const eventTimer = 5 * 60 * 1000;  //every 5 minutes
setInterval(()=>{
  listEvents();
}, eventTimer);

const shouldLoadEventsFromAPI=()=>{
  const now = Date.now();
  const lastTime = localStorage.getObject(`${STORAGE_ROOT}event_load`);
  const data = localStorage.getObject(`${STORAGE_ROOT}event_data`);
  if(lastTime == null || data == null) { 
    localStorage.setObject(`${STORAGE_ROOT}event_load`, now); 
    return true;
  }
  return (now - lastTime) > eventTimer;
}

 const listEvents=()=>{
  if (!shouldLoadEventsFromAPI()) { 
    renderEvents();
    return; 
  }
  const query = new Parse.Query("Event");
  query.find().then((ers) => {
      eventRules = ers;
      getPersonalEvents();
      getCompanyEvents();
      getHowdyEvents();
  }).catch(function(e){  
    handleParseError('Error when getting events data.', e);
  });
 }

 const getPersonalEvents=()=>{
  pEventsLoaded = false; 
  var endpoint_uri = SERVER_URL + PEVENTS_ENDPOINT + '?user_id='+ funsizerId + '&id_token=' + funsierIdToken;
  // console.log('uir ' + endpoint_uri);
  const xhr = new XMLHttpRequest();
  xhr.onload =()=> {
    if(xhr.status == 200) {
      var data = JSON.parse(xhr.responseText);
      const events = data.message;
      // console.log('[[[[personal events]]]')
      // console.log(events)
      pEventsLoaded = true;
      pEvents = [];
      createEventObjects(events, pEvents);
      reconcileEvents();
    }
    else {
      console.log('Ooops! ' + xhr.status + ': ' + xhr.responseText); 
    }
  };
  xhr.open('GET', endpoint_uri, true);
  // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  // xhr.setRequestHeader('X-Parse-Javascript-Key', JAVASCRIPT_KEY);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('X-Parse-REST-API-Key', REST_API_KEY);
  xhr.setRequestHeader('X-Parse-Application-Id', APP_ID);
  xhr.withCredentials = true;
  xhr.send();
}

const getCompanyEvents=()=>{
  cEventsLoaded = false;
  var endpoint_uri = SERVER_URL + CEVENTS_ENDPOINT + '?user_id='+ funsizerId + '&id_token=' + funsierIdToken;
  // console.log('uir ' + endpoint_uri);
  const xhr = new XMLHttpRequest();
  xhr.onload =()=> {
    if(xhr.status == 200) {
      var data = JSON.parse(xhr.responseText);
      const events = data.message;
      // console.log('[[[[company events]]]')
      // console.log(events)
      cEvents = [];
      createEventObjects(events, cEvents);
      cEventsLoaded = true;
      reconcileEvents();
    }
    else {
      console.log('Ooops! ' + xhr.status + ': ' + xhr.responseText); 
    }
  };
  xhr.open('GET', endpoint_uri, true);
  // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  // xhr.setRequestHeader('X-Parse-Javascript-Key', JAVASCRIPT_KEY);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('X-Parse-REST-API-Key', REST_API_KEY);
  xhr.setRequestHeader('X-Parse-Application-Id', APP_ID);
  xhr.withCredentials = true;
  xhr.send();
}

const getHowdyEvents=()=>{
  cEventsLoaded = false;
  var endpoint_uri = SERVER_URL + HEVENTS_ENDPOINT + '?user_id='+ funsizerId + '&id_token=' + funsierIdToken;
  // console.log('uir ' + endpoint_uri);
  const xhr = new XMLHttpRequest();
  xhr.onload =()=> {
    if(xhr.status == 200) {
      var data = JSON.parse(xhr.responseText);
      const events = data.message;
      // console.log('[[[[howdy events]]]')
      // console.log(events)
      hEvents = [];
      createEventObjects(events, hEvents);
      hEventsLoaded = true;
      reconcileEvents();
    }
    else {
      console.log('Ooops! ' + xhr.status + ': ' + xhr.responseText); 
    }
  };
  xhr.open('GET', endpoint_uri, true);
  // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  // xhr.setRequestHeader('X-Parse-Javascript-Key', JAVASCRIPT_KEY);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('X-Parse-REST-API-Key', REST_API_KEY);
  xhr.setRequestHeader('X-Parse-Application-Id', APP_ID);
  xhr.withCredentials = true;
  xhr.send();
}

const WEEK_LENGTH = 604800000;
const createEventObjects=(a, dest)=>{
  //TODO: Do this correctly by adding an "exact match" option to the event object
  //KLUDGE: If Keyword begins with '*' then that means exact match. Parse those first
  var exacts = eventRules.filter(rule => rule.get('Keyword').includes('*'));
  var softs = eventRules.filter(rule => !rule.get('Keyword').includes('*'));

  var filtered = a.filter(item => {
    // console.log(item.summary)
    var matches = false;

    for(var i = 0;i < exacts.length;i++){
      const check = exacts[i].get('Keyword').replace('*','');
      matches = item.summary == check;
      if(matches){
        const excluded = exacts[i].get('ExcludedWords');
        if(excluded){
          const excl = excluded.split(',');
          for(var j = 0;j < excl.length;j++){
            if(matches && item.summary.includes(excl[j])) { matches = false; }
          }
        }
      }
      if(matches){
        //TODO: This is another total kludge because I know we just have anniversaries to contend with atm...need proper categories in the DB
        item.category = exacts[i].get('Keyword').includes('HH') ? 'Happy Hour' : 'Anniversary';
        // item.category = exacts[i].get('Keyword');
        item.imageUrl = exacts[i].get('Image').url();
        item.countdown = exacts[i].get('Countdown');
        item.categoryIconKeyword = item.category.replace(' ', '');
        break;
      }
    }

    if(!matches) {
      for(var i = 0;i < softs.length;i++){
        matches = item.summary.includes(softs[i].get('Keyword'));
        if(matches){
          const excluded = softs[i].get('ExcludedWords');
          if(excluded){
            const excl = excluded.split(',');
            for(var j = 0;j < excl.length;j++){
              if(matches && item.summary.includes(excl[j])) { matches = false; }
            }
          }
        }
        if(matches){
          item.category = softs[i].get('Keyword');
          item.imageUrl = softs[i].get('Image').url();
          item.countdown = softs[i].get('Countdown');
          item.categoryIconKeyword = item.category.replace(' ', '');
          break;
        }
      }
    }

    return matches;
  });
  if (filtered.length == 0) { return; }

  const nowD = new Date();
  nowD.setDate(nowD.getDate() - (nowD.getDay()-1)); // Setting date to last Monday
  nowD.setHours(0,0,0,0); // Setting Hour to 00:00:00:00

  filtered.forEach(i => {
    var obj = new Object();
    obj.category = i.category;
    obj.categoryIconKeyword = i.categoryIconKeyword;
    obj.countdown = i.countdown;
    obj.imageUrl = i.imageUrl;
    obj.title = i.summary;
    obj.allDay = i.start.date != null;
    obj.location = '';
    if(i.location){
      const locs = i.location.split(',')  
      obj.location = locs[0]; 
    }
    var startD = new Date(i.start.dateTime);
    if (obj.allDay){
      const tempD = new Date(i.start.date);
      startD = new Date(tempD.getFullYear(), tempD.getMonth(), tempD.getDate()+1);
    }
    // console.log(startD)
    obj.trueDate = startD;
    const thisWeek = nowD.getTime() <= startD.getTime() && startD.getTime() < (nowD.getTime() + WEEK_LENGTH);
    obj.time = '';
    if(obj.allDay){
      const tempEndD = new Date(i.end.date);
      const endD = new Date(tempEndD.getFullYear(), tempEndD.getMonth(), tempEndD.getDate());
      //if end is not start, show duration 
      var addendum = '';
      if(startD.getTime() != endD.getTime()){
        if(thisWeek){
          addendum = ` - ${endD.toLocaleString('en-US', { weekday: 'short' })}, ${endD.toLocaleString('en-US', { month: 'short' })} ${endD.getDate()} ${addendum}`;
        }
        else {
          addendum = ` - ${endD.toLocaleString('en-US', { month: 'short' })} ${endD.getDate()} ${addendum}`;
        }
      }
      //if this week show day and date otherwise just date
      if(thisWeek){
        obj.date = `${startD.toLocaleString('en-US', { weekday: 'short' })}, ${startD.toLocaleString('en-US', { month: 'short' })} ${startD.getDate()} ${addendum}`;
      }
      else {
        obj.date = `${startD.toLocaleString('en-US', { month: 'short' })} ${startD.getDate()} ${addendum}`;
      }
    }
    else {
      //if this week show day otherwise date 
      if(thisWeek){
        obj.date = `${startD.toLocaleString('en-US', { weekday: 'short' })}`;
      }
      else {
        obj.date = `${startD.toLocaleString('en-US', { month: 'short' })} ${startD.getDate()}`;
      }

      var startH = startD.getHours(); 
      startH = startH > 12 ? startH - 12 : startH;
      var startM = startD.getMinutes();
      startM = startM < 10 ? ':0'+startM : ':'+startM;
      startM = startD.getHours() >= 12 ? 'pm' : 'am';
      const endD = new Date(i.end.dateTime); 
      var endH = endD.getHours();
      endH = endH > 12 ? endH - 12 : endH;
      var endM = endD.getMinutes();
      endM = endM < 10 ? ':0'+endM : ':'+endM;
      endM = endD.getHours() >= 12 ? 'pm' : 'am';
      obj.time = `, ${startH}${startM}-${endH}${endM}`
    }
    if(obj.countdown){
        const n = new Date();
        const date1 = Date.UTC(startD.getFullYear(), startD.getMonth(), startD.getDate());
        const date2 = Date.UTC(n.getFullYear(), n.getMonth(), n.getDate());
        var ms = Math.abs(date1-date2);
        obj.daysRemaining = Math.floor(ms/1000/60/60/24);
        obj.isDayOfEvent = obj.daysRemaining == 0;
        obj.isReallyFarOff = obj.daysRemaining > 99;
        const dif = obj.daysRemaining.toString().split('');
        if(dif.length == 1) {
          obj.firstNum = 0;
          obj.secondNum = dif[0];
        }
        else{
          obj.firstNum = dif[0];
          obj.secondNum = dif[1];
        }
    }
    dest.push(obj);
  });
}

const reconcileEvents=()=>{
  if(!pEventsLoaded || !cEventsLoaded || !hEventsLoaded) { return; }
  var all = pEvents;
  all = all.concat(cEvents);
  all = all.concat(hEvents);
  all = [...new Map(all.map((m) => [m.title+m.date, m])).values()]; //get rid of dupes
  all.sort((a,b)=>{ return a.trueDate - b.trueDate; }); //sort by date
  //ensure there is only 1 countdown event, and make it the second item in the list
  var hasCountDown = false;
  var countDownIndex = -1;
  for(var i = 0;i < all.length;i++) {
    if(all[i].countdown && !hasCountDown) { 
      countDownIndex = i;
      hasCountDown = true; 
    }
    else { all[i].countdown = false; }
  }
  if(countDownIndex > 1) {
    const obj = all.splice(countDownIndex, 1)[0];
    all.splice(1, 0, obj);
  }
  if(all.length > 15){
    all = all.slice(0,15);
  }
  if(all.length > 0) {
    const now = Date.now();
    localStorage.setObject(`${STORAGE_ROOT}event_load`, now);
    localStorage.setObject(`${STORAGE_ROOT}event_data`, all);
  }
  renderEvents();
}

const renderEvents=()=>{
  gsap.to(document.getElementsByClassName('loader-container')[0], {opacity: 0, duration: 0.25});
  const events = localStorage.getObject(`${STORAGE_ROOT}event_data`);
  const eventContainer = document.getElementById('events');
  gsap.to(eventContainer, {opacity: 1, duration: 0.5, delay: 0.25});
  eventContainer.innerHTML = '';
  if(!events || events.length == 0) { 
    //TODO: Empty state
    return;
  }
  for(var i=0;i<events.length;i++) {
    const event = events[i];

    if (event.countdown == true) {
      const countdownContainer = document.createElement('section');
      const countdownDetails = document.createElement('div');
      const countdown3js = document.createElement('div');
      const countdownContentContainer = document.createElement('div');
      const countdownTitle = document.createElement('h2');
      const countdownMetadataContainer = document.createElement('div');
      const countdownMetadataTime = document.createElement('p');
      const countdownLocationContainer = document.createElement('div');
      const countdownLocationImage = document.createElement('img');
      const countdownLocation = document.createElement('p');
      const countdownImage = document.createElement('div');

      countdownContainer.classList.add('card', 'countdown');
      countdownDetails.classList.add('card-details');
      countdown3js.classList.add('big-number');
      countdownContentContainer.classList.add('countdown-info');
      countdownMetadataContainer.classList.add('metadata');
      countdownLocationContainer.classList.add('wrap');
      countdownImage.classList.add('card-image');

      countdownTitle.innerHTML = (event.isDayOfEvent ? event.title + " IS HERE!" : (event.isReallyFarOff ? `${event.daysRemaining} DAYS UNTIL ` + event.title : "DAYS UNTIL " + event.title));
      countdownMetadataTime.innerHTML = event.date + event.time;
      countdownLocationContainer.style.display = (event.location == '' ? 'none' : 'auto');
      countdownLocationImage.src = icons.filter(i => i.keyword == 'MapPinWhite')[0].image;
      countdownLocation.innerHTML = event.location;
      countdownImage.style.backgroundImage = "url(" + (event.imageUrl) + ")";

      eventContainer.append(countdownContainer);
      countdownContainer.append(countdownDetails, countdownImage);
      countdownDetails.append(countdown3js, countdownContentContainer);
      countdownContentContainer.append(countdownTitle, countdownMetadataContainer);
      countdownMetadataContainer.append(countdownMetadataTime, countdownLocationContainer);
      countdownLocationContainer.append(countdownLocationImage, countdownLocation);
      setUpFx(countdown3js, event.firstNum, event.secondNum, event.isDayOfEvent, event.isReallyFarOff);

    } else {
      const cardContainer = document.createElement('div');
      const cardDetails = document.createElement('div');
      const cardCategoryContainer = document.createElement('div');
      const cardCategoryImg = document.createElement('img');
      const cardCategory = document.createElement('p');
      const cardContentContainer = document.createElement('div');
      const cardContentTitle = document.createElement('h2');
      const cardMetadataContainer = document.createElement('div');
      const cardMetadataTime = document.createElement('p');
      const cardLocationContainer = document.createElement('div');
      const cardLocationImage = document.createElement('img');
      const cardLocation = document.createElement('p');
      const cardImage = document.createElement('div');
  
      cardContainer.classList.add('card', 'event');
      cardDetails.classList.add('card-details');
      cardCategoryContainer.classList.add('wrap');
      cardMetadataContainer.classList.add('metadata');
      cardLocationContainer.classList.add('wrap');
      cardImage.classList.add('card-image');
  
      const icon = icons.filter(i => i.keyword == event.categoryIconKeyword);
      if(icon.length>0){
        cardCategoryImg.src = icon[0].image;
      }
      cardCategory.innerHTML = event.category;
      cardContentTitle.innerHTML = event.title;
      cardMetadataTime.innerHTML = event.date + event.time;
      cardLocationContainer.style.display = (event.location == '' ? 'none' : 'auto');
      cardLocationImage.src = icons.filter(i => i.keyword == 'MapPin')[0].image;
      cardLocation.innerHTML = event.location;
      cardImage.style.backgroundImage = "url(" + (event.imageUrl) + ")";

      eventContainer.append(cardContainer);
      cardContainer.append(cardDetails, cardImage);
      cardDetails.append(cardCategoryContainer, cardContentContainer);
      cardCategoryContainer.append(cardCategoryImg, cardCategory);
      cardContentContainer.append(cardContentTitle, cardMetadataContainer);
      cardMetadataContainer.append(cardMetadataTime, cardLocationContainer);
      cardLocationContainer.append(cardLocationImage, cardLocation);
    }
  }
}

const setUpFx=(parent, num1, num2, isDayOfEvent, isReallyFarOff)=>{
  const webgl = document.createElement('canvas');
  webgl.id = 'webgl';
  webgl.classList.add('webgl-card');
  parent.append(webgl);
  if(isDayOfEvent) {
    initializeFX(webgl,null,null,false,'random', true, false);
  }
  else if(isReallyFarOff) {
    initializeFX(webgl,null,null,false,'random', false, true);
  }
  else {
    initializeFX(webgl,parseInt(num1),parseInt(num2),false,'random', false, false);
  }
}

function handleParseError(msg, err) {
  switch (err.code) {
    case Parse.Error.INVALID_SESSION_TOKEN:
      alert('Invalid session token.');
      Parse.User.logOut();
      window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}login.html?redirect=${window.location.pathname}`;
      break;
    default:
      console.log(`${msg} : ${err.code} - ${err.message}`);
  }
}

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
}